module.exports = __webpack_public_path__ + "img/6.ec0b39da.webp";